import { useEffect, useState } from 'react';
import { Box, Grid2 as Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { MainCard } from '../../../component/cards/MainCard2';
import { SelectionButton, SubmitButton } from '../../../component/buttons';
import { TabPanel } from '../../../component/tabPanel';
import HeaderCard from './HeaderUserAdd';
import PersonalBodyCard from './body/PersonalBodyCard';
import MedicalBodyCard from './body/MedicalBodyCard';
import { gridSpacing } from 'store/constant';
import { useFormikAddUser } from 'hooks/useFormikAddUser';
import { getGroups } from 'services/groups';
import { GroupSelector } from './body/GroupSelector';
import { useTranslation } from 'react-i18next';

function Users() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();

    const roleToTypeValue = {
        PATIENT: 0,
        DOCTOR: 1,
        CLINIC_ADMIN: 2,
        CLINIC_CARE_GIVER: 3,
        PATIENT_CARE_GIVER: 4
    };

    const preselectedRole = location.state?.preselectedType;
    const preselectedType = preselectedRole ? roleToTypeValue[preselectedRole] : 0;
    const formik = useFormikAddUser(preselectedType);
    const [tab, setTab] = useState(0);

    const [availableGroups, setAvailableGroups] = useState([]);

    const tabs = [
        [t('users.tabs.personalData'), t('users.tabs.medicalData')],
        [t('users.tabs.personalData')]
    ];

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const res = await getGroups();
                setAvailableGroups(res);
            } catch (err) {
                console.error('Erro ao procurar grupos', err);
            }
        };
        fetchGroups();
    }, []);

    return (
        <MainCard title={t('users.newUser')}>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={gridSpacing}>
                    <Grid size={12}>
                        <HeaderCard
                            values={formik.values}
                            handleChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid container size={12}>
                        {tabs[formik.values.type === 0 ? 0 : 1].map((tabName, index) => (
                            <Grid key={index} size={12 / tabs.length}>
                                <SelectionButton
                                    selected={tab === index}
                                    sx={{
                                        width: '100%',
                                        py: 2
                                    }}
                                    onClick={() => setTab(index)}
                                >
                                    {tabName}
                                </SelectionButton>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid size={12}>
                        <TabPanel value={tab} index={0}>
                            <PersonalBodyCard formik={formik} />
                        </TabPanel>
                        <TabPanel value={tab} index={1}>
                            <MedicalBodyCard formik={formik} />
                        </TabPanel>
                    </Grid>
                    <Grid
                        container
                        size={12}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mt: 2
                        }}
                    >
                        <GroupSelector
                            values={formik.values}
                            handleChange={formik.handleChange}
                            groups={availableGroups}
                            width={400}
                        />
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <SubmitButton
                                type="button"
                                onClick={() => navigate('/users', { replace: true })}
                            >
                                {t('common.cancel')}
                            </SubmitButton>

                            <SubmitButton
                                disabled={formik.isSubmitting}
                                name="submit"
                                type="submit"
                            >
                                {t('common.save')}
                            </SubmitButton>
                        </Box>
                    </Grid>
                </Grid>
            </form>
        </MainCard>
    );
}

export default Users;
